import { Color } from '@persona-id/design-tokens';
import { MutableRefObject, useEffect, useState } from 'react';
import styled from 'styled-components';

import GraphDataChangeEvent from 'dashboard/components/GraphCanvasV2/events/graph-data-change-event';
import GraphOverviewPanelItem from 'dashboard/components/GraphExplorerPanel/GraphOverviewPanelItem';
import GraphPropertiesPanelItem from 'dashboard/components/GraphExplorerPanel/GraphPropertiesPanelItem';
import { useEventBus } from 'dashboard/components/GraphModule/hooks/useEventBus';
import { useGraphExplorer } from 'dashboard/components/GraphModule/hooks/useGraphExplorer';
import { FULL_SCREEN_HEADER_HEIGHT } from 'dashboard/layouts/ShowViewLayoutV2';
import { Z_INDICES } from 'dashboard/styles/variables';

const PanelContainer = styled.div`
  background-color: ${({ theme }) => theme.color.background.primary};
  border-left: 1px solid ${Color.CoreSlate100};
  width: 400px;
  height: calc(100vh - ${FULL_SCREEN_HEADER_HEIGHT}px);
  flex-direction: column;
  user-select: none;

  overflow: hidden;
  z-index: ${Z_INDICES.floatingBar};
`;

export interface GraphExplorerPanelProps {
  elRef: MutableRefObject<HTMLDivElement>;
}

const GraphExplorerPanel = ({ elRef }: GraphExplorerPanelProps) => {
  const eventBus = useEventBus();
  const { graphExplorer } = useGraphExplorer();
  const { getVertexTypeCount } = graphExplorer;
  const [renderCount, setRenderCount] = useState<number>(0);

  const handleGraphDataChangeEvent = (_e: GraphDataChangeEvent) => {
    // Force a rerender from here on down.
    //
    // HAX: There's a ton of graph explorer state to unpack, so we choose to do a localized rerender here,
    // rather than passing the entire payload down from the top-level route.
    setRenderCount(renderCount + 1);
  };

  useEffect(() => {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    eventBus.addEventListener(GraphDataChangeEvent.type, handleGraphDataChangeEvent);

    return function cleanupEventListeners() {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      eventBus.removeEventListener(GraphDataChangeEvent.type, handleGraphDataChangeEvent);
    };
  });

  return (
    <PanelContainer
      id='graph-explorer-panel'
      data-test='graph-explorer-panel__container'
      data-graph-target='display-panel'
      ref={elRef}
    >
      <GraphOverviewPanelItem getVertexTypeCount={getVertexTypeCount} renderCount={renderCount} />
      <GraphPropertiesPanelItem renderCount={renderCount} />
    </PanelContainer>
  );
};

export default GraphExplorerPanel;
